import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!clerkPubKey) {
  console.error('Missing REACT_APP_CLERK_PUBLISHABLE_KEY environment variable');
}

// Brand the Clerk widget to match the Floobiz palette.
const clerkAppearance = {
  variables: {
    colorPrimary: '#7CC242',
    colorBackground: '#15336A',
    colorText: '#F4E7CC',
    colorTextSecondary: '#9A9AA8',
    colorInputBackground: '#F4E7CC',
    colorInputText: '#15336A',
    colorDanger: '#C8302C',
    colorSuccess: '#7CC242',
    borderRadius: '12px',
    fontFamily: '"DM Sans", system-ui, -apple-system, sans-serif',
  },
  elements: {
    rootBox: { width: '100%' },
    card: {
      backgroundColor: '#15336A',
      border: '1px solid rgba(255, 255, 255, 0.08)',
      boxShadow: '0 24px 60px rgba(0, 0, 0, 0.45)',
    },
    headerTitle: { fontFamily: '"Unbounded", sans-serif', fontWeight: 500 },
    formButtonPrimary: {
      backgroundColor: '#7CC242',
      color: '#15336A',
      textTransform: 'none',
      fontWeight: 700,
    },
    formButtonPrimary__hover: { backgroundColor: '#95D44E' },
    socialButtonsBlockButton: {
      borderColor: 'rgba(255, 255, 255, 0.12)',
      color: '#F4E7CC',
    },
    // OTP / verification code digit inputs — force readable contrast so the
    // typed code isn't dark-on-dark against the navy card background.
    otpCodeFieldInput: {
      backgroundColor: '#F4E7CC',
      color: '#15336A',
      borderColor: 'rgba(255, 255, 255, 0.2)',
      caretColor: '#15336A',
    },
    formFieldInput: {
      backgroundColor: '#F4E7CC',
      color: '#15336A',
      caretColor: '#15336A',
    },
    // "Don't have an account? Sign up" / "Already have an account? Sign in"
    footerActionText: { color: '#ffffff' },
    footerActionLink: { color: '#ffffff', fontWeight: 600 },
    // UserButton popover ("Manage account", "Sign out", etc.)
    userButtonPopoverActionButton: { color: '#ffffff' },
    userButtonPopoverActionButtonText: { color: '#ffffff' },
    userButtonPopoverActionButtonIcon: { color: '#ffffff' },
    userButtonPopoverFooter: { color: '#ffffff' },
  },
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ClerkProvider publishableKey={clerkPubKey} appearance={clerkAppearance}>
      <App />
    </ClerkProvider>
  </React.StrictMode>
);

reportWebVitals();
